import type { MAIL_STATUS } from 'cpool-constants';
import { MAIL_STATUS_RETRIES, MAIL_STATUS_RETRY_INTERVAL, MAIL_STATUSES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetLoanRequestMailStatusData } from 'cpool-tables/backend-resolvers';
import { schemaLoanRequestResolver_GetLoanRequestMailStatusData } from 'cpool-tables/backend-resolvers';
import { sleep } from 'cpool-utils';
import type { TFunction } from 'i18next';
import { toast } from 'react-toastify';

import i18n from '~/lib/i18n.ts';
import { fetcher } from '~/queryUtils/useQuery';

type Props = {
    aggregateId: string;
    correlationId: string;
    t: TFunction<'de' | 'en', undefined>;
    i18n: typeof i18n;
};

export const verifyLoanRequestMailStatus = async ({ aggregateId, correlationId, t }: Props) => {
    try {
        let mailStatus: MAIL_STATUS = MAIL_STATUSES.PENDING;
        let errorMessage: string | undefined;
        let counter = 0;
        /* eslint-disable no-await-in-loop */
        while (mailStatus === MAIL_STATUSES.PENDING && counter < MAIL_STATUS_RETRIES) {
            await sleep(MAIL_STATUS_RETRY_INTERVAL);
            const response: SchemaLoanRequestResolver_GetLoanRequestMailStatusData = await fetcher({
                meta: {
                    queryUrl: `/query/loan-request/getLoanRequestMailStatusData?id=${aggregateId}&correlationId=${correlationId}`,
                    schema: schemaLoanRequestResolver_GetLoanRequestMailStatusData,
                },
            });
            if (response) {
                mailStatus = response.status;
                errorMessage = response.error;
            }
            counter += 1;
        }
        /* eslint-enable no-await-in-loop */
        if (mailStatus === MAIL_STATUSES.PENDING) {
            toast.info(t('STATUS.STATUS_MAIL.TIMEOUT_TOAST'));
            return;
        }
        if (mailStatus === MAIL_STATUSES.FAILED) {
            if (errorMessage && i18n.exists(`STATUS.STATUS_MAIL.FAILED_TOAST.${errorMessage}`)) {
                toast.error(`STATUS.STATUS_MAIL.FAILED_TOAST.${errorMessage}`);
                return;
            }
            toast.error(t('STATUS.STATUS_MAIL.FAILED_TOAST.UNKNOWN_ERROR'));
            return;
        }
        toast.success(t('STATUS.STATUS_MAIL.SUCCESS_TOAST'));
    } catch (error) {
        toast.error(t('STATUS.STATUS_MAIL.FAILED_TOAST.CANNOT_BE_SENT'));
    }
};
